export const statsConstants = {
  STATS_LOAD: '[Stats] Load',
  STATS_LOAD_SUCCESS: '[Stats] Load success',
  STATS_LOAD_FAILURE: '[Stats] Load failure',
  STATS_RESET: '[Stats] Reset',
  STATS_CAMPAIGN_LOAD: '[Stats] Campaign load',
  STATS_CAMPAIGN_LOAD_SUCCESS: '[Stats] Campaign load success',
  STATS_CAMPAIGN_LOAD_FAILURE: '[Stats] Campaign load failure'
}
